import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";

@Component({
	selector: 'bill-type',
	standalone: true,
	template: `
        <select class="form-control form-control-sm btn-secondary" [(ngModel)]="data" [disabled]="disabled" (change)="onChange()">
            <option *ngFor="let i of billTypes" value="{{i.code}}">{{ i.description }}</option>
        </select>
	`,
	imports: [
		FormsModule,
		CommonModule
	],
	styles:[`
		select{
			font-size: 20px;
		}
	`]
})
export class BillTypeSelect{
	
	@Input()
	disabled:boolean = false;
	
	@Input()
	selected!:string;
	
	@Input()
	data:string = "";
	
	@Output()
	dataChange:EventEmitter<string> = new EventEmitter();
	
	
	onChange(e?: any){
		this.dataChange.emit(this.data);
	}
	
	
	billTypes:Array<{code:string,description:string}> = [
		{code:"OB", description:"[OB] Master"},
		{code:"BM", description:"[BM] House"}
	];
	
	constructor() {}
}
